@if (viewModel) {
	<app-document-section-expand-buttons [viewModel]="viewModel"></app-document-section-expand-buttons>
	<div class="scroll-vertical">
		@if (viewModel.sections.length === 1) {
			<ng-container *ngTemplateOutlet="taskSectionContent; context: { task: task }"></ng-container>
			<app-document-section [section]="viewModel.sections[0]" [viewModel]="viewModel" [isReadOnly]="isReadOnly"></app-document-section>
		}
		@else {
			@if (task.manifest.canBeUrgent || task.manifest.summarySettings.userCanEdit) {
				<app-expander class="validatable-section" [formGroup]="taskPropertiesForm">
					<app-item-label class="validation-section-label">Task properties</app-item-label>
					<ng-container *ngTemplateOutlet="taskSectionContent; context: { task: task }"></ng-container>
				</app-expander>
			}
			@for (section of viewModel.sections; track section.id; let index = $index) {
				<app-expander class="validatable-section" [formGroup]="viewModel.sectionGroups[section.id]">
					<app-item-label class="validation-section-label">{{section.metaData.title}}</app-item-label>
					<app-document-section [section]="section" [viewModel]="viewModel" [isReadOnly]="isReadOnly"></app-document-section>
				</app-expander>
			}
		}
	</div>
}
<ng-template #taskSectionContent let-task="task">
	<div class="form-section">
		@if (task.manifest.summarySettings.userCanEdit) {
			<div class="form-group" [formGroup]="summaryForm!">
				<app-textarea class="validatable-control" [readOnly]="isReadOnly" [label]="task.manifest.summarySettings.displayLabel" [placeholder]="task.manifest.summarySettings.displayPlaceholder" debounce formControlName="summary">
				</app-textarea>
			</div>
		}
		@if (task.manifest.canBeUrgent) {
			<div class="form-group validatable-group" [formGroup]="urgentForm!">
				<app-checkbox [readOnly]="isReadOnly" label="URGENT REQUEST" formControlName="urgent">
				</app-checkbox>
				<app-textarea class="validatable-group-control" [readOnly]="isReadOnly" label="Give reason for urgency" placeholder="reason..." debounce formControlName="urgentReason">
				</app-textarea>
			</div>
		}
	</div>
</ng-template>